/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    /* eslint-disable no-underscore-dangle */
    function treatment() {
        document.documentElement.classList.add('w26');

        var headerRowOnly = location.pathname === '/' || location.pathname === '/search';
        if (headerRowOnly) {
            document.documentElement.classList.add('header-row-only');
        }

        var oldIconNode = document.querySelector('.site-nav__icons button.js-drawer-open-nav'),
            newIconNode = oldIconNode.cloneNode(true);

        document.querySelector('h2.site-header__logo, .h2.site-header__logo').insertAdjacentElement('beforebegin', newIconNode);
        newIconNode.classList.add('new');
        newIconNode.addEventListener('click', function () {
            oldIconNode.click();
        });

        var header = document.querySelector('header.site-header');

        // Full combo
        document.documentElement.classList.add('full-combo');
        var submitBtn = document.querySelector('.site-header__search-container button[type="submit"]');
        document.querySelector('.site-header__search-container button.js-search-header-close')
            .insertAdjacentElement('afterend', submitBtn);

        var searchInput = document.querySelector('.site-header__search-input'),
            inputPlaceholder = 'Search 5,200+ baby products';
        searchInput.placeholder = inputPlaceholder;

        // Prevent boost filter & search from changing searchbox's placeholder.
        Mojito.utils.watchElement(searchInput, function () {
            if (searchInput._changeByMe) {
                searchInput._changeByMe = false;
                return;
            }

            searchInput._changeByMe = true;
            searchInput.placeholder = inputPlaceholder;
        }, { attributes: true });

        submitBtn.addEventListener('click', function () {
            document.querySelector('.site-header__search-form').submit();
        });

        var oldSearchIconNode = header.querySelector('a.site-nav__link.js-search-header'),
            newSearchIconNode = oldSearchIconNode.cloneNode(true);

        oldSearchIconNode.insertAdjacentElement('afterend', newSearchIconNode);
        newSearchIconNode.classList.add('new');
        newSearchIconNode.addEventListener('click', function (e) {
            e.preventDefault();
            if (document.documentElement.classList.contains('open-search')) {
                document.documentElement.classList.remove('open-search');
                var searchResultNode = document.querySelector('.algolia-autocomplete');
                if (searchResultNode) {
                    searchResultNode.style.display = 'none';
                }
            } else {
                document.documentElement.classList.add('open-search');
                adjustAlgoliaResultPosition();
                searchInput.focus();
            }
        });

        var adjustAlgoliaResultPosition = function () {
            test.injectCSS('.open-search .algolia-autocomplete {top:' + (document.documentElement.scrollTop + 105) + 'px !important;}');
        };

        var startX = headerRowOnly ? 60 : 0;
        window.addEventListener('scroll', function () {
            if (document.documentElement.scrollTop > startX) {
                header.classList.add('collapse');
            } else {
                header.classList.remove('collapse');

                if (headerRowOnly && document.documentElement.classList.contains('open-search')) {
                    var searchResultNode = document.querySelector('.algolia-autocomplete');
                    if (searchResultNode) {
                        searchResultNode.style.display = 'none';
                    }
                }

                document.documentElement.classList.remove('open-search');
            }
        });

        window.setTimeout(function () {
            header.querySelector('.site-header__search-container').classList.add('transition');
            jQuery(newSearchIconNode).off('click');
        }, 500);

        var stringTrim = function (str) {
            return str == null ? '' : (str + '').replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };

        var imageMap = {
            prams: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Pram_140px.png',
            nursery: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Nursery_140px.png',
            playtime: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Playtime_140px.png?v=1733457066',
            feeding: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Feeding_140px.png',
            bath: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Bath_140px.png',
            clothing: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Clothing_140px.png',
            carriers: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Carriers_140px.png',
            'car seats': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Car_Seats_140px.png',
            gifts: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Gifts_140px_v2.png',
            sale: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Sale_140px_v3.png',
            'gift registry': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Gift_Registry_140px.png?v=1733457067',
            'out &amp; about': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Out_And_About_140px.jpg?v=1733457066',
            'monitors': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Monitor_140px.jpg?v=1733457066',
            'baby carriers': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Carriers_140px.png',
            'mb rewards': 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Rewards_140px.jpg?v=1733457066',
            brands: 'https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w26_Brands_140px.jpg'

        };
        

        var addMenuImage = function (element) {
            var label = stringTrim(element.innerHTML);
            if (element.tagName === 'BUTTON') {
                label = stringTrim(element.querySelector('.mobile-nav__faux-link').innerHTML);
            }

            var image = imageMap[label.toLowerCase()];
            if (image) {
                element.style.backgroundImage = 'url("' + image + '")';
            }
        };

        Mojito.utils.observeSelector('.mobile-nav__item .mobile-nav__link--top-level', addMenuImage);
    }

    function trigger() {
        if (location.pathname.indexOf('/checkouts/') !== -1 || location.pathname.indexOf('/orders/') !== -1) {
            return;
        }

        if (Math.min(window.innerWidth, window.innerHeight) > 768 || !('ontouchstart' in document.documentElement)) {
            return;
        }

        Mojito.utils.domReady(treatment);
    }

    // Start the trigger
    trigger();
})();
